




















































import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { CompanyUserDto } from '@/dto/company-user/company-user.dto';
import { BaseUser } from '../../../services/shared/auth';
import companyUserService from '../../../services/company-user.service';
import store from '@/store';
import { APPROVAL_STATUS } from '@/services/shared';
import jwtStorageService from '@/services/shared/auth/jwt-storage.service';
import ApprovalStatusChangeInfoText from '@/modules/_common/components/info-text/ApprovalStatusChangeInfoText.vue';
@Component({
  name: 'infoChangeDialog',
  components: { ApprovalStatusChangeInfoText },
})
export default class InfoChangeDialog extends BaseComponent {
  private companyUserDto = new CompanyUserDto(BaseUser);
  private loading = false;
  private originalCompanyUserDto = {};
  @Prop() readonly dialog: boolean;

  get isInputChanged() {
    // dto가 원래데이터와 다르면 true return else return false
    if (
      JSON.stringify(this.originalCompanyUserDto) ==
      JSON.stringify(this.companyUserDto)
    ) {
      return false;
    } else {
      return true;
    }
  }

  reset() {
    // this.userAddDialog = false;
    this.$emit('update:dialog', !this.dialog);
    this.loading = false;
    this.getMyInfo();
  }
  getMyInfo() {
    companyUserService.findMe().subscribe(res => {
      this.companyUserDto = res.data;
      this.originalCompanyUserDto = { ...this.companyUserDto };
    });
  }
  requestChange() {
    this.loading = true;
    companyUserService.change(this.companyUserDto).subscribe(res => {
      if (res) {
        companyUserService.getTokenById().subscribe(res => {
          jwtStorageService.setToken(res.data.token);
          this.reset();
          this.$toasted.global.custom_success({
            message: '정보 변경 신청 성공!',
          });
        });
      }
      this.loading = false;
    });
  }
  created() {
    this.getMyInfo();
  }
}
